module.exports = __webpack_public_path__ + "img/activity_22.e79b45d8.jpg";